import { Component, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ContactRegional } from '../../../interfaces/contact-regional.interface';

@Component({
    selector: 'app-contact-regional',
    templateUrl: './contact-regional.component.html',
    styleUrls: ['./contact-regional.component.scss'],
    imports: [TranslatePipe]
})
export class ContactRegionalComponent {
    public readonly regionalcontacts = input<ContactRegional[]>([]);

    protected readonly rows = computed(() => this.regionalcontacts().filter(Boolean));
}
